import React from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'
import { Tab as TabInterface } from '.'

interface PropsStyles {
  isActive?: boolean
}

const WrapperTab = styled.div<PropsStyles>`
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-width: 0;
  border-bottom: ${(props) => (props.isActive ? '3px solid #e02020' : 0)};
  padding-bottom: 5px;
  cursor: pointer;

  > svg {
    fill: #010b19;
    width: 25px;
  }

  .compact-menu-tab-item-text {
    font-size: 12px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }
`

interface TabProps extends TabInterface {
  isActive?: boolean
  onClick: () => void
}

const TabBox = (props: TabProps) => {
  const { label, icon, isActive = false, onClick, dataTest } = props

  return (
    <WrapperTab data-test={dataTest} onClick={onClick} isActive={isActive}>
      {icon}
      <span className="compact-menu-tab-item-text">{label}</span>
    </WrapperTab>
  )
}

interface Props {
  tabs?: TabInterface[]
  slug?: string
}

function TabsMobile(props: Props) {
  const { tabs, slug = '' } = props

  return (
    <>
      {tabs?.map((tab) => (
        <TabBox
          dataTest={tab.dataTest}
          key={tab.label}
          label={tab.label}
          icon={tab.icon}
          isActive={tab.slug === slug}
          onClick={() => {
            navigate(`${tab.slug}`)
          }}
        />
      ))}
    </>
  )
}

export default TabsMobile
